import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Elemento } from 'app/domain/elementos';
import { Adjunto } from 'app/domain/adjunto';

@Injectable({
  providedIn: 'root'
})
export class ParametrosSistemaService {

  url: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(public httpClient: HttpClient) {
    this.url = environment.URL_SICO + 'parametrosSistema/';
  }

  public consultarNumeroRemisiones(): Observable<any> {
    return this.httpClient.post(this.url + 'consultarNumeroRemisiones/', this.httpOptions);
  }

  public consultarReferenciaFlete(): Observable<any> {
    return this.httpClient.post(this.url + 'consultarReferenciaFlete/', this.httpOptions);
  }

  public urlPdfPromociones(): Observable<any> {
    return this.httpClient.post(this.url + 'urlPdfPromociones/', this.httpOptions);
  }

  public actualizarUrlPdfPromociones(request: Adjunto): Observable<any> {
    return this.httpClient.post(this.url + 'actualizarUrlPdfPromociones/', request, this.httpOptions);
  }

  public sucursalObsequio(): Observable<any> {
    return this.httpClient.get(this.url + 'sucursalObsequio/', this.httpOptions);
  }

  public sucursalModifica(): Observable<any> {
    return this.httpClient.get(this.url + 'sucursalModifica/', this.httpOptions);
  }

  public gruposDescuento(): Observable<any> {
    return this.httpClient.get(this.url + 'gruposDescuento/', this.httpOptions);
  }
}
